/** InsCoder WANG.J 2026-04-20 B + Mobile sticky sold out notify button **/
(() => {
  const MOBILE_BREAKPOINT = 749;
  const CONTAINER_SELECTOR = '.product-form__buttons';
  const BUTTON_SELECTOR = '.product-form__submit.button--soldout[data-action="klaviyonotify"]';
  const controllers = new WeakMap();

  class MobileStickySoldoutController {
    constructor(container) {
      this.container = container;
      this.button = null;
      this.sentinel = null;
      this.spacer = null;
      this.ticking = false;
      this.isRefreshing = false;
      this.handleClick = this.handleClick.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleMutations = this.handleMutations.bind(this);
      this.mutationObserver = new MutationObserver(this.handleMutations);
      this.container.addEventListener('click', this.handleClick, true);
      this.observeContainer();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.refresh();
    }

    destroy() {
      this.mutationObserver.disconnect();
      this.container.removeEventListener('click', this.handleClick, true);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.removeStickyArtifacts();
    }

    observeContainer() {
      this.mutationObserver.observe(this.container, { childList: true, subtree: true });
    }

    handleMutations() {
      if (this.isRefreshing) return;
      this.refresh();
    }

    handleClick(event) {
      const triggerButton = event.target.closest(BUTTON_SELECTOR);
      if (!triggerButton || !this.container.contains(triggerButton)) return;

      const scopedTrigger =
        this.container.querySelector('a.klaviyo-bis-trigger') ||
        this.container.closest('.product')?.querySelector('a.klaviyo-bis-trigger') ||
        document.querySelector('a.klaviyo-bis-trigger');

      if (!scopedTrigger) return;

      event.preventDefault();
      event.stopPropagation();
      scopedTrigger.click();
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateStickyState();
        this.ticking = false;
      });
    }

    handleResize() {
      this.syncSpacerHeight();
      this.updateStickyState();
    }

    refresh() {
      this.isRefreshing = true;
      this.mutationObserver.disconnect();
      this.removeStickyArtifacts();

      this.button = this.container.querySelector(BUTTON_SELECTOR);

      if (this.button) {
        this.button.classList.add('cust-main-product-soldout-sticky__button');

        this.sentinel = document.createElement('span');
        this.sentinel.className = 'cust-main-product-soldout-sticky__sentinel';
        this.sentinel.setAttribute('aria-hidden', 'true');

        this.spacer = document.createElement('span');
        this.spacer.className = 'cust-main-product-soldout-sticky__spacer';
        this.spacer.setAttribute('aria-hidden', 'true');

        this.button.insertAdjacentElement('beforebegin', this.sentinel);
        this.button.insertAdjacentElement('afterend', this.spacer);

        this.syncSpacerHeight();
        this.updateStickyState();
      }

      this.observeContainer();
      this.isRefreshing = false;
    }

    removeStickyArtifacts() {
      this.container.classList.remove('cust-main-product-soldout-sticky--active');

      this.container
        .querySelectorAll('.cust-main-product-soldout-sticky__sentinel, .cust-main-product-soldout-sticky__spacer')
        .forEach((node) => node.remove());

      const previousButton = this.container.querySelector('.cust-main-product-soldout-sticky__button');
      if (previousButton) {
        previousButton.classList.remove('cust-main-product-soldout-sticky__button', 'is-mobile-sticky');
      }

      this.button = null;
      this.sentinel = null;
      this.spacer = null;
    }

    syncSpacerHeight() {
      if (!this.button || !this.spacer) return;
      this.spacer.style.setProperty('--cust-main-product-soldout-sticky-height', `${this.button.offsetHeight}px`);
    }

    updateStickyState() {
      if (!this.button || !this.sentinel || !this.spacer) return;

      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
      const shouldStick = isMobile && this.sentinel.getBoundingClientRect().top <= 0;

      this.button.classList.toggle('is-mobile-sticky', shouldStick);
      this.spacer.classList.toggle('is-active', shouldStick);
      this.container.classList.toggle('cust-main-product-soldout-sticky--active', shouldStick);
    }
  }

  function initMobileStickySoldoutButtons() {
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      const controller = controllers.get(container);

      if (controller) {
        controller.refresh();
        return;
      }

      controllers.set(container, new MobileStickySoldoutController(container));
    });
  }

  function teardownMobileStickySoldoutButtons(root = document) {
    root.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      const controller = controllers.get(container);
      if (!controller) return;
      controller.destroy();
      controllers.delete(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileStickySoldoutButtons);
  } else {
    initMobileStickySoldoutButtons();
  }

  document.addEventListener('shopify:section:load', initMobileStickySoldoutButtons);
  document.addEventListener('shopify:section:unload', (event) => {
    teardownMobileStickySoldoutButtons(event.target);
  });
})();
/** InsCoder WANG.J 2026-04-20 E + Mobile sticky sold out notify button **/
